<template>
  <div class="content">
    <h1>Contact</h1>
    <div>Have a question or concern? Is the site not working correctly, or do you have a suggestion for improvement? Contact us!</div>
    <div></div>
    <div><a href="mailto:info@sharemyscrapbook.com">info@sharemyscrapbook.com</a></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.content
  padding 0 30px

h1
  border-bottom: 2px dotted #189ea6;
</style>
